import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";

const SecureRoute = ({ auth, routeData, component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (auth) return <Component routeData={routeData} {...props} />;
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }}
    />
  );
};

SecureRoute.propTypes = {
  auth: PropTypes.bool.isRequired,
  routeData: PropTypes.any,
  component: PropTypes.elementType.isRequired,
  location: PropTypes.object,
};

export default SecureRoute;
